import { FC, useState } from 'react';
import { Loader2Icon, SendIcon } from 'lucide-react';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import axios from 'axios';

import { API_BASE_URL } from '@/constants';
import { NbButton, NbCard, NbField, NbPageHeader } from '@/components/Neobrut';

export const ForgotPassword: FC = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<{ email: string }>();
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (data: { email: string }) => {
    setIsLoading(true);
    try {
      const formattedData = { ...data, email: data.email.toLowerCase() };
      const response = await axios.post(`${API_BASE_URL}/users/password-reset/`, formattedData);
      if (response.status === 200) {
        toast.info(response.data.message);
      }
    } catch {
      // error silenced — backend always returns 200 if email exists.
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mx-auto w-full max-w-md pb-10">
      <NbPageHeader
        slug="/ forgot-password"
        title={
          <>
            Contraseña
            <br />
            <span className="nb-highlight">olvidada.</span>
          </>
        }
        subtitle="Te mandamos un link por email para reestablecerla."
        tone="plain"
      />
      <form onSubmit={handleSubmit(onSubmit)} className="px-4 pt-4">
        <NbCard className="flex flex-col gap-4 p-4">
          <NbField
            id="email"
            label="Email"
            type="email"
            autoComplete="email"
            error={errors.email?.message}
            {...register('email', { required: 'El campo email es requerido' })}
          />
          <NbButton fill="ink" type="submit" className="w-full py-3" disabled={isLoading}>
            {isLoading ? (
              <Loader2Icon className="h-4 w-4 animate-spin" />
            ) : (
              <SendIcon size={14} />
            )}
            Enviar link
          </NbButton>
        </NbCard>
      </form>
    </div>
  );
};
